import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import RefundAppEditPage from "./RefundAppEditPage";
import RefundAppListPage from "./RefundAppListPage";
import RefundEmailSettingsPage from "./RefundEmailSettingsPage";
import RefundEventSettingsPage from "./RefundEventSettingsPage";
import RefundEventSettingsEditPage from "./RefundEventSettingsPage/editPage";
import RefundVenueSettingsPage from "./RefundVenueSettingsPage";
import RefundVenueSettingsEditPage from "./RefundVenueSettingsPage/editPage";
import RefundTNCPage from "./RefundTNCPage";
import RefundFilmNamesPage from "./RefundFilmNamesPage";

export default function RefundPages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/application-list`}
        component={withPermission(
          RefundAppListPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/application-list/:id`}
        component={withPermission(
          RefundAppEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/event-settings`}
        component={withPermission(
          RefundEventSettingsPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/event-settings/:id`}
        component={withPermission(
          RefundEventSettingsEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/venue-settings`}
        component={withPermission(
          RefundVenueSettingsPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/venue-settings/:id`}
        component={withPermission(
          RefundVenueSettingsEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/email-content-settings`}
        component={withPermission(
          RefundEmailSettingsPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/terms-and-conditions`}
        component={withPermission(
          RefundTNCPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/film-names`}
        component={withPermission(
          RefundFilmNamesPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}/application-list`} />} />
    </Switch>
  );
}
